import { IAgentCityEntity } from '../../model/api/agent/agent-city.entity.interface';
import { IAgentCity } from '../../model/models/agent/agent-city.interface';
import { IAgentEntity } from '../../model/api/agent/agent.entity.interface';
import { IAgent } from '../../model/models/agent/agent.interface';
import { IAgentLocationEntity } from '../../model/api/agent/agent-location.entity.interface';
import { IAgentLocation } from '../../model/models/agent/agent-location.interface';
import { APP_CONFIG } from '../../environment';
import { PriceCalculatorProvider } from '../../providers/price-calculator/price-calculator';

export class AgentMapper {

  public static fromAgentLocationEntities(entities: IAgentLocationEntity[]): IAgentLocation[] {
    return entities.map((entity: IAgentLocationEntity) => AgentMapper.fromAgentLocationEntity(entity));
  }

  public static fromAgentLocationEntity(entity: IAgentLocationEntity): IAgentLocation {
    // Orders can have null agent info. For example, if the order delivery method is bank deposit and not office pickup.
    return entity === null ? null : {
      agentId: entity.agentToId,
      agentName: entity.agentToName,
      locationId: entity.locationId,
      locationName: entity.locationName,
      locationAddress: entity.locationAddress,
      locationAddress2: entity.locationAddress2,
      locationCity: entity.locationCity,
      locationState: entity.locationState,
      currency: entity.currency,
      phone: entity.phone,
      locationType: entity.locationType,
      collectionLocation: entity.collectionLocation,
      payoutLocation: entity.payoutLocation,
      sendLocation: entity.sendLocation,
      businessHours: this.formatBusinessHours(entity.businessHours),
      latitude: entity.latitude,
      longitude: entity.longitude
    }
  }

  public static formatBusinessHours(businessHours) {
    const result = [];
    if (businessHours) {
      for (let i=0; i < businessHours.length; i++) {
        const businessHour = businessHours[i];
        if (businessHour.timeOpen) {
          const hour = businessHour.dayOfWeek + ': ' + businessHour.timeOpen + ' - ' + businessHour.timeClose + ' ' + businessHour.timeZoneAbbrev;
          result.push(hour);
        }
      }
    }
    return result;
  }

  public static fromAgentEntities(entities: IAgentEntity[]): IAgent[] {
    const agents: IAgent[] = [];
    entities.forEach((entity) => agents.push(this.fromAgentEntity(entity)));
    return agents;
  }

  public static fromAgentEntity(entity: IAgentEntity): IAgent {
    return {
      id: entity.id,
      locationId: entity.locationId,
      name: entity.name,
      digitalAlias: entity.digitalAlias,
      city: entity.city,
      state: entity.state,
      country: entity.country,
      locationCount: entity.locationCount,
      isOpenPayment: entity.openPayment,
      currency: entity.currency,
      customerRate: PriceCalculatorProvider.updateRate(entity.customerRate),
      rateDecimals: entity.rateDecimals,
      logoUrl: `${APP_CONFIG.remittanceApiBaseUrl}agent/logo/${entity.id}?useMobile=true`,
      displayOrder: entity.displayOrder,
      payoutType: entity.payoutType,
      isPremiumRate: entity.isPremiumRate,
      selectedAgentToInfoList: entity.selectedAgentToInfoList,
      correspondentPayoutBrand: entity.correspondentPayoutBrand,
      digitalCorrespondentGroups: entity.digitalCorrespondentGroups

    };
  }

  public static fromAgentCitiesEntity(entities: IAgentCityEntity[]): IAgentCity[] {
    const cities :IAgentCity[] = [];
    entities.forEach(entity => cities.push({
      cityName: entity.cityName,
      cityId: entity.cityId,
      stateAbbreviation: entity.stateAbbrev,
      state: entity.state,
    }));
    return cities
  }
}



// WEBPACK FOOTER //
// ./src/providers/agent/agent.mapper.ts